﻿import { Button, Checkbox, Select, Space, Typography } from 'antd';
import type { AnalyticsDimension, AnalyticsMeasure, QueryDefinition } from '../../../types/survey-analytics.types';

const dimensions: Array<{ value: AnalyticsDimension; label: string }> = [
  { value: 'gender', label: 'Gênero' },
  { value: 'age_group', label: 'Faixa etária' },
  { value: 'education', label: 'Escolaridade' },
  { value: 'economic_level', label: 'Nível econômico' },
  { value: 'state', label: 'Estado' },
];
const measures: Array<{ value: AnalyticsMeasure; label: string }> = [
  { value: 'COUNT', label: 'Contagem' },
  { value: 'PERCENT_WITHIN_GROUP', label: '% no grupo' },
  { value: 'PERCENT_OPTION_DISTRIBUTION', label: '% da opção' },
];

export function PivotControls({ definition, onChange, onRun }: { definition: QueryDefinition; onChange: (definition: QueryDefinition) => void; onRun: () => void }) {
  const pivot = definition.mode === 'PIVOT' ? definition : { ...definition, mode: 'PIVOT' as const, dimension: 'gender' as AnalyticsDimension };
  return (
    <Space wrap align="center">
      <Typography.Text strong>Pivot</Typography.Text>
      <Select aria-label="Dimensão" value={pivot.dimension} style={{ minWidth: 180 }} options={dimensions} onChange={(dimension) => onChange({ ...pivot, dimension })} />
      <Select aria-label="Medidas" mode="multiple" value={pivot.measures} style={{ minWidth: 260 }} options={measures} onChange={(next) => onChange({ ...pivot, measures: next.length ? next : ['COUNT'] })} />
      <Checkbox checked={Boolean(pivot.transpose)} onChange={(event) => onChange({ ...pivot, transpose: event.target.checked })}>Transpor</Checkbox>
      <Button type="primary" onClick={onRun}>Aplicar pivot</Button>
    </Space>
  );
}
export default PivotControls;
